import { render, staticRenderFns } from "./IntelligentWizardView.vue?vue&type=template&id=3cb92a84&scoped=true"
import script from "./IntelligentWizardView.vue?vue&type=script&lang=js"
export * from "./IntelligentWizardView.vue?vue&type=script&lang=js"
import style0 from "./IntelligentWizardView.vue?vue&type=style&index=0&id=3cb92a84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb92a84",
  null
  
)

export default component.exports